import React from "react";
import { UI_Modal, UI_Modal_OTP } from "../../UiComponents/index";

function VerifyOTPModal(props) {
  const {
    isSignUpSuccess,
    setIsSignUpSuccess,
    otp,
    setOpt,
    handleSubmitOtp,
    inValidOtp,
    setInValidOtp,
    handleResendOtp,
  } = props;
  return (
    <>
      <UI_Modal_OTP
        isOpen={isSignUpSuccess}
        closeModal={() => {
          setIsSignUpSuccess(false);
          localStorage.clear();
        }}
        title="Verify One Time Password"
      >
        <div className=" px-2 py-2 mt-3 mx-3 sccess_text items-start text-white">
          <div className="sccess_text">
            <h1>Enter One Time Password From Your Registerd Email ID</h1>
          </div>
          <div className="otp_container">
            <input
              type="number"
              className="otp_input w-[25%]  p-1 user_input"
              value={otp}
              onChange={(e) => setOpt(e.target.value)}
            />
          </div>
          <p className="inValidOtp">{inValidOtp ? inValidOtp : null}</p>
        </div>

                <div className="flex-col mt-1 otp_btn_container items-center">
                    <button className="submit_btn_ui text-lg w-24"
                        onClick={handleSubmitOtp}
                    >Submit</button>
                    <button className="cancel_btn_ui text-sm mt-3"
                         onClick={handleResendOtp}
                    >Resend Code</button>
                </div>
            </UI_Modal_OTP>
        </>
    )
}

export default VerifyOTPModal;
